// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"SurveyRadioButtonGroup_fullWidth__I2AsT","lastChildBorder":"SurveyRadioButtonGroup_lastChildBorder__T_JVJ"};